import React from 'react'
import { Route, Redirect } from 'react-router-dom'

export function PrivateRoute({ user, role, isAzureAuthenticated, children, ...rest }) {
  return (
    <Route
      {...rest}
      render={() => {
        // return isAuthenticated ? children : <Redirect to="/login" />
        return isAzureAuthenticated ? children : null
      }}
    />
  )
}
